module.exports = __webpack_public_path__ + "aa6d71d381196460e1d1ce83b871645a.svg";